import type { Schemas } from '#shopware'

export const categoryIncludes: Schemas['Includes'] = {
    category: [
        'id',
        'active',
        'translated',
        'name',
        'media',
        'metaTitle',
        'metaDescription',
        'seoUrls',
        'customFields.custom_category_name_for_listing',
        'customFields.prevent_indexing',
        'breadcrumb',
        'cmsPage'
    ],
    seo_url: [
        'pathInfo', 
        'isCanonical', 
        'seoPathInfo'
    ],
}
